import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import "./District.css";

const url = process.env.REACT_APP_BACKEND_URL;

const District = () => {

  const [submitting, setSubmitting] = useState(false);

  const [data, setData] = useState({
    name: "",
    country: "",
    region: ""
  });

  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);

  const navigate = useNavigate();

  // Fetch Countries
  useEffect(() => {

    const fetchCountries = async () => {
      try {

        const response = await axios.get(`${url}/api/country`);

        setCountries(response.data.data || []);

      } catch (error) {

        toast.error("Failed to load countries");

      }
    };

    fetchCountries();

  }, []);


  // Fetch Regions when country changes
  useEffect(() => {

    const fetchRegions = async () => {

      if (!data.country) {
        setRegions([]);
        return;
      }

      try {

        const response = await axios.get(`${url}/api/Regions?country=${data.country}`);

        setRegions(response.data.data || []);

      } catch (error) {

        toast.error("Failed to load regions");

      }
    };

    fetchRegions();

  }, [data.country]);


  const onChangeHandler = (event) => {

    const { name, value } = event.target;

    setData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "country" ? { region: "" } : {})
    }));

  };


  const onSubmitHandler = async (event) => {

    event.preventDefault();

    if (!data.name || !data.country || !data.region) {
      toast.error("All fields are required");
      return;
    }

    try {

      setSubmitting(true);

      const response = await axios.post(`${url}/api/district`, data);

      if (response.data.success) {

        toast.success("District added successfully!");

        setData({
          name: "",
          country: "",
          region: ""
        });

        navigate("/ViewDistrict");

      }

    } catch (error) {

      const errorMessage = error.response?.data?.message || "Failed to add district";

      toast.error(errorMessage);

    } finally {

      setSubmitting(false);

    }

  };


  return (
    <div className="district-container">

      <div className="header">
        <h2>Add New District</h2>

        <button
          onClick={() => navigate("/ViewDistrict")}
          className="add-button"
        >
          <Plus size={16} /> View Districts
        </button>

      </div>


      <form className="district-form" onSubmit={onSubmitHandler}>

        <div className="form-group">
          <label>District Name</label>

          <input
            type="text"
            name="name"
            value={data.name}
            onChange={onChangeHandler}
            required
          />
        </div>


        <div className="form-group">
          <label>Country</label>

          <select
            name="country"
            value={data.country}
            onChange={onChangeHandler}
            required
          >

            <option value="">Select Country</option>

            {countries.map((country) => (
              <option key={country._id} value={country._id}>
                {country.name}
              </option>
            ))}

          </select>

        </div>


        <div className="form-group">
          <label>Region</label>

          <select
            name="region"
            value={data.region}
            onChange={onChangeHandler}
            required
            disabled={!data.country}
          >

            <option value="">Select Region</option>

            {regions.map((region) => (
              <option key={region._id} value={region._id}>
                {region.name}
              </option>
            ))}

          </select>

        </div>


        <div className="form-actions">

          <button
            type="submit"
            className="submit-button"
            disabled={submitting}
          >
            {submitting ? "Processing..." : "Add District"}
          </button>

          <button
            type="button"
            onClick={() => navigate("/ViewDistrict")}
            className="cancel-button"
          >
            Cancel
          </button>

        </div>

      </form>

    </div>
  );
};

export default District;